import * as Mutations from '../../mutations';

export default {
  [Mutations.SET_PERMISSIONS](store, permissions) {
    store.permissions = permissions;
  },
};
